import * as React from "react";

function SvgGooglePlay(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 126 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M121.361 36.824H5.395c-2.55 0-4.64-2.037-4.64-4.523V5.165c0-2.487 2.09-4.523 4.64-4.523H121.36c2.55 0 4.639 2.036 4.639 4.523V32.3c0 2.486-2.089 4.523-4.639 4.523z"
        fill="#000"
      />
      <path
        d="M121.361 1.367c2.148 0 3.896 1.704 3.896 3.798V32.3c0 2.094-1.748 3.798-3.896 3.798H5.395c-2.148 0-3.896-1.704-3.896-3.798V5.165c0-2.094 1.748-3.798 3.896-3.798H121.36zm0-.725H5.395c-2.55 0-4.64 2.036-4.64 4.523V32.3c0 2.486 2.09 4.523 4.64 4.523H121.36c2.55 0 4.639-2.037 4.639-4.523V5.165c0-2.487-2.089-4.523-4.639-4.523z"
        fill="#A6A6A6"
      />
      <path
        d="M10.438 7.461c-.273.278-.43.711-.43 1.272v20.004c0 .56.158.994.43 1.272l.067.061 11.497-11.205v-.264L10.505 7.396l-.067.065z"
        fill="url(#googlePlay_svg__paint0_linear_1891_24384)"
      />
      <path
        d="M25.83 22.602l-3.828-3.737v-.264l3.833-3.737.085.048 4.54 2.518c1.295.715 1.295 1.89 0 2.61l-4.54 2.513-.09.05z"
        fill="url(#googlePlay_svg__paint1_linear_1891_24384)"
      />
      <path
        d="M25.922 22.553l-3.918-3.82-11.565 11.276c.43.441 1.132.494 1.93.053l13.553-7.509z"
        fill="url(#googlePlay_svg__paint2_linear_1891_24384)"
      />
      <path
        d="M25.922 14.912L12.37 7.404c-.798-.437-1.5-.384-1.93.057l11.565 11.272 3.918-3.82z"
        fill="url(#googlePlay_svg__paint3_linear_1891_24384)"
      />
      <path
        d="M44.748 9.908c0 .755-.232 1.36-.689 1.811-.525.535-1.21.804-2.048.804-.801 0-1.486-.273-2.047-.813-.562-.547-.843-1.219-.843-2.022 0-.804.28-1.476.843-2.019.561-.544 1.246-.817 2.047-.817.399 0 .78.08 1.142.23.362.15.657.353.87.604l-.485.477c-.372-.428-.879-.64-1.527-.64-.585 0-1.091.2-1.522.6-.425.403-.639.925-.639 1.565 0 .64.214 1.165.64 1.568.43.397.936.6 1.521.6.62 0 1.142-.203 1.554-.605.271-.265.425-.632.466-1.1h-2.02v-.653h2.695c.032.14.042.278.042.41zM49.024 7.642h-2.532v1.719h2.282v.653h-2.282v1.719h2.532v.666h-3.249V6.976h3.249v.666zM52.041 12.399h-.717V7.642h-1.552v-.666h3.823v.666H52.04V12.4zM56.363 12.399V6.976h.716V12.4h-.716zM60.25 12.399h-.71V7.642h-1.56v-.666h3.829v.666h-1.56V12.4zM69.046 11.701c-.548.549-1.228.822-2.038.822-.816 0-1.495-.273-2.044-.822-.547-.547-.82-1.219-.82-2.013 0-.795.273-1.467.82-2.014.549-.549 1.228-.822 2.044-.822.806 0 1.485.273 2.034.826.552.552.824 1.22.824 2.01 0 .794-.272 1.466-.82 2.013zm-3.552-.454c.413.406.915.61 1.514.61.594 0 1.1-.204 1.508-.61.412-.406.62-.927.62-1.56 0-.632-.208-1.153-.62-1.559a2.063 2.063 0 00-1.508-.61c-.599 0-1.1.204-1.514.61-.411.406-.62.927-.62 1.56 0 .632.209 1.153.62 1.559zM70.871 12.399V6.976h.87l2.704 4.218h.032l-.032-1.043V6.976h.716V12.4h-.747l-2.832-4.426h-.031l.031 1.047V12.4h-.71z"
        fill="#fff"
        stroke="#fff"
        strokeWidth={0.111}
        strokeMiterlimit={10}
      />
      <path
        d="M63.967 20.318c-2.179 0-3.96 1.617-3.96 3.848 0 2.213 1.781 3.846 3.96 3.846 2.184 0 3.964-1.633 3.964-3.846 0-2.231-1.78-3.848-3.964-3.848zm0 6.18c-1.196 0-2.224-.963-2.224-2.332 0-1.387 1.028-2.333 2.224-2.333 1.196 0 2.229.946 2.229 2.333 0 1.37-1.033 2.331-2.229 2.331zm-8.638-6.18c-2.184 0-3.96 1.617-3.96 3.848 0 2.213 1.776 3.846 3.96 3.846 2.182 0 3.959-1.633 3.959-3.846 0-2.231-1.777-3.848-3.96-3.848zm0 6.18c-1.197 0-2.23-.963-2.23-2.332 0-1.387 1.033-2.333 2.23-2.333 1.195 0 2.224.946 2.224 2.333 0 1.37-1.029 2.331-2.224 2.331zm-10.28-5v1.634h4.005c-.117.914-.43 1.586-.91 2.054-.585.565-1.495 1.193-3.095 1.193-2.464 0-4.394-1.94-4.394-4.342 0-2.403 1.93-4.342 4.394-4.342 1.333 0 2.302.508 3.018 1.166l1.181-1.152c-1-.932-2.332-1.648-4.199-1.648-3.379 0-6.219 2.681-6.219 5.976s2.84 5.975 6.22 5.975c1.826 0 3.198-.583 4.276-1.678 1.105-1.077 1.45-2.592 1.45-3.816 0-.38-.033-.729-.09-1.02h-5.637zm42.034 1.267c-.326-.86-1.332-2.447-3.38-2.447-2.029 0-3.719 1.56-3.719 3.848 0 2.155 1.673 3.846 3.914 3.846a3.934 3.934 0 003.289-1.705l-1.345-.874c-.449.64-1.06 1.064-1.944 1.064-.878 0-1.507-.392-1.91-1.165l5.277-2.13-.182-.437zm-5.381 1.281a2.135 2.135 0 012.06-2.243c.69 0 1.274.335 1.469.816l-3.53 1.427zm-4.29 3.732h1.735V16.472h-1.735v11.306zm-2.841-6.603h-.058c-.39-.45-1.133-.857-2.075-.857-1.976 0-3.782 1.692-3.782 3.86 0 2.156 1.806 3.834 3.782 3.834.942 0 1.685-.41 2.075-.874h.058v.552c0 1.471-.806 2.261-2.106 2.261-1.06 0-1.717-.746-1.989-1.373l-1.508.614c.434 1.02 1.586 2.275 3.497 2.275 2.034 0 3.75-1.167 3.75-4.006v-6.909h-1.644v.623zm-1.984 5.322c-1.196 0-2.197-.976-2.197-2.319 0-1.355 1.001-2.345 2.197-2.345 1.178 0 2.107.99 2.107 2.345 0 1.343-.929 2.32-2.107 2.32zm22.618-10.025h-4.15v11.306h1.73v-4.284h2.42c1.921 0 3.806-1.355 3.806-3.512 0-2.155-1.89-3.51-3.806-3.51zm.045 5.45h-2.464v-3.878h2.464a1.987 1.987 0 012.03 1.938c0 .876-.738 1.94-2.03 1.94zm10.696-1.625c-1.25 0-2.55.538-3.085 1.73l1.535.628c.331-.627.939-.83 1.581-.83.898 0 1.808.525 1.822 1.453v.119c-.313-.176-.983-.438-1.808-.438-1.654 0-3.339.888-3.339 2.544 0 1.515 1.355 2.491 2.877 2.491 1.165 0 1.807-.512 2.211-1.108h.059v.874h1.671v-4.337c0-2.005-1.535-3.126-3.524-3.126zm-.209 6.196c-.566 0-1.354-.274-1.354-.958 0-.875.983-1.21 1.834-1.21.762 0 1.119.163 1.582.379-.136 1.047-1.06 1.789-2.062 1.789zm9.821-5.949l-1.989 4.902h-.059l-2.056-4.902h-1.866l3.09 6.85-1.763 3.811h1.808l4.76-10.66h-1.925zm-15.596 7.234h1.735V16.472h-1.735v11.306z"
        fill="#fff"
      />
      <defs>
        <linearGradient
          id="googlePlay_svg__paint0_linear_1891_24384"
          x1={20.982}
          y1={28.945}
          x2={5.806}
          y2={13.381}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00A0FF" />
          <stop offset={0.007} stopColor="#00A1FF" />
          <stop offset={0.26} stopColor="#00BEFF" />
          <stop offset={0.512} stopColor="#00D2FF" />
          <stop offset={0.76} stopColor="#00DFFF" />
          <stop offset={1} stopColor="#00E3FF" />
        </linearGradient>
        <linearGradient
          id="googlePlay_svg__paint1_linear_1891_24384"
          x1={32.146}
          y1={18.732}
          x2={9.698}
          y2={18.732}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFE000" />
          <stop offset={0.409} stopColor="#FFBD00" />
          <stop offset={0.775} stopColor="orange" />
          <stop offset={1} stopColor="#FF9C00" />
        </linearGradient>
        <linearGradient
          id="googlePlay_svg__paint2_linear_1891_24384"
          x1={23.791}
          y1={16.656}
          x2={3.212}
          y2={-4.451}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF3A44" />
          <stop offset={1} stopColor="#C31162" />
        </linearGradient>
        <linearGradient
          id="googlePlay_svg__paint3_linear_1891_24384"
          x1={7.529}
          y1={36.664}
          x2={16.718}
          y2={27.239}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#32A071" />
          <stop offset={0.069} stopColor="#2DA771" />
          <stop offset={0.476} stopColor="#15CF74" />
          <stop offset={0.801} stopColor="#06E775" />
          <stop offset={1} stopColor="#00F076" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default SvgGooglePlay;
